
import AMCConstants from './AMCConstants.js';
import util from "util";
import ZLog from "./zlog";


var ZUtil = {

	randomElement:  function(array) {
		if (array.length === 0) {
			return null;
		}
		return array[Math.floor(Math.random() * array.length)];
	},
	getAppNodeOfKind(app, kind) {
		for (let i = 0; i < app.nodes.length; ++i) {
			if (app.nodes[i].kind === kind) {
				return app.nodes[i];
			}
		}
		return null;
	},
	getAppNodesOfKind(app, kind) {
		let results = [];
		for (let i = 0; i < app.nodes.length; ++i) {
			if (app.nodes[i].kind === kind) {
				results.push(app.nodes[i]);
			}
		}
		return results;
	},
	getQueryParms() {
		let str = window.location.search.substring(1) || "";
		let parms = {};
		if (str.length > 0) {
			str.split("&").forEach( p => { 
				let splits = p.split("=");
				parms[splits[0]] = splits[1];
			});
		}
		return parms;
	},
	// must be same as in api
	hashCode(str) {
		var hash = 0;
		for (var i = 0; i < str.length; i++) {
			var code = str.charCodeAt(i);
			hash = ((hash<<5)-hash) + code;
			hash = hash & hash; // Convert to 32bit integer
		}
		return hash;
	},
	hash(obj) {
		if (!obj) {
			return obj;
		}
		if (typeof obj === "number") {
			return obj;
		}
		if (typeof obj === "string") {
			let hash = 0;
			for (var i = 0; i < obj.length; i++) {
				var code = obj.charCodeAt(i);
				hash = ((hash<<5)-hash) + code;
				hash = hash & hash; // Convert to 32bit integer
			}
			return hash;
		}
		let hash = Object.keys(obj).reduce( (hash, key) => (hash << 5) + this.hash(obj[key]) * 3 + this.hash(key), 0 );
		return hash;
	},
	arePropertiesEqual(a, b) {
		let a_keys = Object.keys(a);
		let b_keys = Object.keys(b);
		if (a_keys.length === b_keys.length) {
			for (let i = 0; i < a_keys.length; ++i) {
				if (a_keys[i] !== b_keys[i] || a[a_keys[i]] !== b[a_keys[i]]) {
					return false;
				}
			}
			return true;
		}
		return false;
	},
	capitalize(str) {
		return str[0].toUpperCase() + str.substring(1);
	},
	min3(a, b, c) {
		return Math.min(a, Math.min(b, c));
	},
	editDistance(a, b) {
		var len = [[]], i, j;
		for (i = 0; i <= a.length; ++i) {
			len[i] = [];
			len[i][0] = i;
		}
		for (j = 0; j <= b.length; ++j) {
			len[0][j] = j;
		}
		for (i = 1; i <= a.length; ++i) {
			for (j = 1; j <= b.length; ++j) {
				if (a[i - 1] === b[j - 1]) {
					len[i][j] = len[i - 1][j - 1];
				} else {
					len[i][j] = 1 + this.min3(len[i - 1][j], len[i][j - 1], len[i - 1][j - 1]);
				}
			}
		}
		return len[a.length][b.length];
	},
	eatEvent(event) {
		event.stopPropagation();
	},
	absorbEvent: function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
	},
	getPlatform() {
		return AMCConstants.platform;
	},
	isProduction: function() {
		return this.getPlatform() === "production";
		//return process.env.NODE_ENV === "production";
	},
	isStaging: function() {
		return this.getPlatform() === "staging";
	},
	isDevelopment: function() {
		return this.getPlatform() !== "staging" && this.getPlatform() !== "production";
	},
	getDataServer: function() {
		return this.isProduction() ? AMCConstants.ROCK_DATA_BUCKET_PRODUCTION : AMCConstants.ROCK_DATA_BUCKET_STAGING;
	},
	idify: function(str) {
		return this.urlify(str.replace(/ /g, '-')).replace(/\//g, '_');
//		return str.replace(/\//g, '_').replace(/ /g, '-');
	},
	noop: function() {
	},
	inspect: function(obj) {
		if (obj === null) {
			return "null";
		}
		if (obj === undefined) {
			return "undefined";
		}
		try {
			var str = JSON.stringify(obj);
		} catch(e) {
			return util.inspect(obj);
		}
		str = str.replace(/,"/g, ',\n"').replace(/},{/g, "},\n{");
		var lines = str.split("\n");
		var formatted = [];
		var line;
		var indent = 0;
		for (var i = 0; i < lines.length; ++i) {
			line = lines[i];
			formatted.push("                                          ".slice(0, 2*indent) + line);
			for (var j = 0; j < line.length; ++j) {
				if (line[j] === '[' || line[j] === '{') {
					++indent;
				} else if (line[j] === ']' || line[j] === '}') {
					--indent;
				}
			}
		}
		return formatted.join("\n");
	},
	addClassname: function(e, name) {
		if (typeof e === "string") {
			e = document.getElementById(e);
		}
		if (e) {
			this.removeClassname(e, name);
			e.className = e.className + " " + name;
		}
	},
	removeClassname: function(e, name) {
		if (typeof e === "string") {
			e = document.getElementById(e);
		}
		if (e) {
			e.className = e.className.replace(name, "").replace("  ", " ");
		}
	},
	pickBounds: function(bounds, left, top) {
//ZLog.log("pickBounds", { bounds: bounds, x: left, y: top });
		return left > bounds.left && left < bounds.left + bounds.width && top > bounds.top && top < bounds.top + bounds.height;
	},
    	pick: function(pickable_classname, x, y) {
		var pickables = document.getElementsByClassName(pickable_classname);
		return this.pickElement(pickables, x, y);
	},
	pickTopElement: function(container, x, y) {
		let all = container.querySelectorAll("*");
		let pickables = ZUtil.nodeListToArray(all).reverse();
		let element = this.pickElement(pickables, x, y);
		return element;
	},
	pickElement: function(pickables, x, y) {
//console.log("pickables.length=" + pickables.length);
		var rect;
		for (var i = 0; i < pickables.length; ++i) {
			rect = pickables[i].getBoundingClientRect();
//console.log("rect=", ZUtil.inspect(rect));
//console.log("x=" + x);
//console.log("y=" + y);
			if (rect.left < x && rect.left + rect.width > x && rect.top < y && rect.top + rect.height > y) {
//console.log("pick SUCCESS");
				return pickables[i];
			}
		}
		return null;
	},
	nodeListToArray: function(nodelist) {
		var arr = [], n;
		for (var i = 0; nodelist[i]; ++i) {
			n = nodelist[i]
			arr.push(n);
		}
		return arr;
	},
   	smartPick: function(container, pickable_classname, x, y, yonly) {
		if (this.DEBUG) {
			if (!this.debugpicker) {
				var footprint = 10;
				this.debugpicker = document.createElement('div');
				this.debugpicktarget = document.createElement('div');
				this.debugpicker.style = "position: absolute; border: 2px solid #f00;" + (yonly ? "width: 100%;" : "width:" + 1 + "px;") + "height:" + footprint + "px; pointer-events: none";
				this.debugpicktarget.style = "position: absolute; border: 1px solid #0a0; pointer-events: none";
				document.body.appendChild(this.debugpicker);
				document.body.appendChild(this.debugpicktarget);
			}
			this.debugpicker.style.top = y + "px";
			if (yonly) {
				this.debugpicker.style.width = "100%";
				this.debugpicker.style.left = null;
			} else {
				this.debugpicker.style.left = x + "px";
				this.debugpicker.style.width = footprint + "px";
			}
		}
			
		var pickables = container.getElementsByClassName(pickable_classname);
//console.log("pickable_classname=" + pickable_classname);
//console.log("pickables.length=" + pickables.length);
		pickables = ZUtil.nodeListToArray(pickables).reverse();
		// TODO go through list of unpickables now and remove all parents from pickables list.
		for (var i = 0; i < pickables.length; ++i) {
			if (pickables[i].className.indexOf("UNPICKABLE") !== -1) {
				return null;
			}
			var rect = pickables[i].getBoundingClientRect();
			if (this.DEBUG) {
				this.debugpicktarget.style.top = rect.top + "px";
				this.debugpicktarget.style.left = rect.left + "px";
				this.debugpicktarget.style.width = rect.width + "px";
				this.debugpicktarget.style.height = rect.height + "px";
			}

			if (yonly && rect.top < y && rect.top + rect.height > y) {
				return { index: i, element: pickables[i] };
			}
			if (rect.left < x && rect.left + rect.width > x && rect.top < y && rect.top + rect.height > y) {
				return { index: i, element: pickables[i] };
			}
		}
//console.error("DNDUtil.smartPick FAIL");
		return null;
    	},
	getBoundingClientRect(element, respect_to) {
		let rect = element.getBoundingClientRect();
		let bounds = { left: rect.left, top: rect.top, right: rect.right, bottom: rect.bottom, width: rect.width, height: rect.height };
		if (typeof respect_to !== "string") {
			let c = respect_to.getBoundingClientRect();
			bounds.left -= c.left;
			bounds.top -= c.top;
			bounds.x -= c.x;
			bounds.y -= c.y;
		} else if (respect_to !== "body" || element.nodeName !== "BODY") {
			while ((element = element.offsetParent) != null) {
				if (respect_to === "grandparent") {
					respect_to = "parent";
				} else {
					rect = element.getBoundingClientRect();
					bounds.left = bounds.left - rect.left;
					bounds.top = bounds.top - rect.top;
					bounds.right = rect.right - bounds.right;
					bounds.bottom = rect.bottom - bounds.bottom;
console.log("element.nodeName=" + element.nodeName + ",rect.top=" + rect.top);
					if (respect_to === "body" && element.nodeName === "BODY") {
						break;
					} else if (respect_to === "parent") {
						break;
					}
				}
			}
		}
		bounds.left += window.scrollX;
		bounds.top += window.scrollY;
		return bounds;
	},
	autoResizeTextarea: function(textarea) {
		setTimeout(function() {
			textarea.style.cssText = 'height:auto; padding:0';
			textarea.style.cssText = 'height:' + textarea.scrollHeight + 'px';
		}, 0);
	},
	toPrice: function(cents) {
		var p = Math.floor(cents/100) + "." + ("0" + (cents % 100)).slice(-2);
		return p.replace('.00','');
	},
	withCommas: function(number) {
		let result = "";
		let splitted = (number + "").split(".");
		while(splitted[0].length > 3) { 
			result = "," + splitted[0].substring(splitted[0].length - 3) + result;
			splitted[0] = splitted[0].substring(0, splitted[0].length - 3);
		}
		result = splitted[0] + result;
		return result + (splitted[1] ? "." + splitted[1] : "");
	},

		

// http://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-clone-an-object
// dies if key's value is a react event
    clone: function(obj) {
//console.log("clone typeof obj =" + (typeof obj));
//console.log("obj =" + obj);
	var temp;
      if (obj === null || typeof(obj) !== 'object' || 'isActiveClone' in obj)
        return obj;

      if (obj instanceof Date) {
//console.log("dying?");
        temp = new obj.constructor(); //or new Date(obj);
      } else {
        temp = obj.constructor();
      }

//console.log("clone typeof obj =" + (typeof obj));
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
//console.log("clone key =" + key);
//console.log("type of obj =" + (typeof obj));
		try {
          obj['isActiveClone'] = null;
          temp[key] = this.clone(obj[key]);
          delete obj['isActiveClone'];
		} catch (e) {
			temp[key] = obj[key];
			ZLog.error("Unable to clone key '" + key + "' in obj");
		}
        }
      }

      return temp;
    },
	// Leaflet... L.Util ... blap
  extend: function(dest) { // (Object[, Object, ...]) ->
	var sources = Array.prototype.slice.call(arguments, 1), i, j, len, src;

	for (j = 0, len = sources.length; j < len; j++) {
		src = sources[j] || {};
		for (i in src) {
			if (src.hasOwnProperty(i)) {
				dest[i] = src[i];
			}
		}
	}
	return dest;
  },
	toShortCount(num) {
		if (num > 1500) {
			let str = Math.floor(num/100) + "";
			return (str.substring(0, str.length - 1) + "." + str.substring(str.length - 1)).replace(".0","") + "k";
		}
		return num + "";
	},
	toShortNumber(num, decimals=2) {
		let str = "" + num;
		let index = str.indexOf(".");
		return index === -1 ? str : str.substring(0, index + decimals + 1);
	},
	toShortFloat(num, decimals=2) {
		return num <= 1500 ? ZUtil.decimalPlaces(num, 2) : ZUtil.toShortCount(num);
	},
  toShortDate(d) {
	if (!d || Number.isInteger(d)) {
		d = new Date(d);
	}
	var datestring = ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + "-" +
		d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
	return datestring;
  },
	toHoursMinutes(millis) {
		return Math.floor(millis/(1000*60*60)) + ":" + ("0" + Math.floor(millis/(1000*60))).slice(-2);
	},
	toHoursMinutesSecs(millis) {
		return Math.floor(millis/(1000*60*60)) + ":" + ("0" + Math.floor(millis/(1000*60))).slice(-2) + ":" + ("0" + Math.floor(millis/(1000))).slice(-2);
	},
	timeagowords: function(millis) {
		let seconds = (Date.now() - millis)/1000;
		var sprintf = function (astring, value) { return astring.replace(/%d/i, value); };

		var is_future = false;
		if (seconds < 0) {
			is_future = true;
			seconds = -seconds;
		}

		var agos = {
			seconds: "a few seconds",
			minute: "a minute",
			minutes: "%d minutes",
			hour: "an hour",
			hours: "%d hours",
			day: "a day",
			days: "%d days",
			month: "a month",
			months: "%d months",
			year: "a year",
			years: "%d years"
			};

		var minutes = seconds / 60;
		var hours = minutes / 60;
		var days = hours / 24;
		var years = days / 365;
 
		var words = 	(seconds < 45 && sprintf(agos.seconds, Math.round(seconds))) ||
				(seconds < 90 && agos.minute) ||
				(minutes < 45 && sprintf(agos.minutes, Math.round(minutes))) ||
				(minutes < 90 && agos.hour) ||
				(hours < 24 && sprintf(agos.hours, Math.round(hours))) ||
				(hours < 48 && agos.day) ||
				(days < 30 && sprintf(agos.days, Math.floor(days))) ||
				(days < 60 && agos.month) ||
				(days < 365 && sprintf(agos.months, Math.floor(days / 30))) ||
				(years < 2 && agos.year) ||
				sprintf(agos.years, Math.floor(years));

		return(is_future ? "in " + words : words + " ago");
	},

  assert: function(condition, msg) {
	if (!condition) {
		console.error(msg)
		console.trace();
	}
  },
	// waits for a pause of pauseMillisecs in the stream to fire
	throttled: function(functionality, data, pauseMillisecs) {
		var DEFAULT_PAUSE_MILLIS = 1000;
		var timeoutHandle;
		return function() {
			if (timeoutHandle) {
				clearTimeout(timeoutHandle);
			}
			timeoutHandle = setTimeout(functionality.bind(this, data, arguments), pauseMillisecs || DEFAULT_PAUSE_MILLIS);
		}
	},
	_throttles: {},
	// waits for a pause of pauseMillisecs in the stream to fire
	throttle: function(id, functionality, pauseMillisecs) {
		var DEFAULT_PAUSE_MILLIS = 1000;
		if (this._throttles[id]) {
			clearTimeout(this._throttles[id]);
		}
		this._throttles[id] = setTimeout(functionality, pauseMillisecs || DEFAULT_PAUSE_MILLIS);
	},
	// fires at most every pauseMillisecs
	_throttlers: {},
	throttler: function(id, functionality, data, pauseMillisecs) {
		var DEFAULT_PAUSE_MILLIS = 1000;
		if (!this._throttlers[id]) {
			this._throttlers[id] = { timer: setTimeout(function() {let data = ZUtil._throttlers[id].data; delete ZUtil._throttlers[id]; functionality.bind(this, data, arguments)() }, pauseMillisecs || DEFAULT_PAUSE_MILLIS), data: data };
		} else {
			this._throttlers[id].data = data;
		}
	},
	_chunkers: {},
	_chunker_timeouts: {},
	// accumulates data into a buffer and fires at most every pauseMillisecs
	clearChunker: function(id) {
		clearTimeout(this._chunker_timeouts[id]);
		delete this._chunkers[id]; 
	},
	chunker: function(id, functionality, data, pauseMillisecs) {
		var DEFAULT_PAUSE_MILLIS = 1000;
		if (!this._chunkers[id]) {
			this._chunkers[id] = [];
			this._chunker_timeouts[id] = setTimeout(function() {
				var data = ZUtil._chunkers[id]; 
				delete ZUtil._chunkers[id]; 
				functionality.bind(this, data, arguments)()
			}, pauseMillisecs || DEFAULT_PAUSE_MILLIS);
		}
		this._chunkers[id].push(data);
	},

	getCandy: function(name) {
		return localStorage.getItem(name);
	},
	setCandy: function(name, value) {
		if (typeof value !== "string") {
			value = JSON.stringify(value);
		}
		localStorage.setItem(name, value);
	},
	deleteCandy: function(name) {
		localStorage.removeItem(name);
	},

	// https://stackoverflow.com/questions/10730362/get-cookie-by-name
	getCookie: function(name) {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		if (parts.length === 2) {
			return unescape(parts.pop().split(";").shift());
		}
		return null;
	},
	setCookie: function(name,value,expiredays) {
		if (typeof expiredays === 'undefined') {
			expiredays = 365;
		}
		var exdate=new Date();
		exdate.setDate(exdate.getDate()+expiredays);
		if (typeof value !== "string") {
			value = JSON.stringify(value);
		}
		document.cookie = name + "=" +escape(value) + ";expires="+exdate.toGMTString() + ";path=/";
	},
	deleteCookie(name) {
		document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
		document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
		document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=" + window.location.hostname;
		document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=." + AMCConstants.DOMAIN_NAME;
		document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=." + window.location.hostname;
  	},
	fingerprint: function() {
		var useragent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : "" + Math.random() * 1000000;
		return this.urlify(useragent);
	},
	urlify: function(str) {
		return unescape(str).toLowerCase().replace(' - ', '-').replace(/\s+/g, '-').replace(/&/g,'and').replace(/[^a-zA-Z0-9_-]+/g, '').substring(0, 70);
	},
	uniq: function(a) {
		var o = {}, i, l = a.length, r = [], k;
		if (l === 1) {
			return [a[0]];
		}
		for(i = 0; i < l; i += 1) {
			 o[a[i]] = true;
		}
		for(k in o) {
			if (o.hasOwnProperty(k)) {
				r.push(k);
			}
		}
		return r;
	},
	getRadioButtonsSelectedValue: function(name) {
		var radios = document.getElementsByName(name);
		for (var i = 0, length = radios.length; i < length; i++) {
			if (radios[i].checked) {
				return radios[i].value;
			}
		}	
		return null;
	},
	getCheckboxButtonsSelectedValue: function(name) {
		var boxes = document.getElementsByName(name), results = [];
		for (var i = 0, length = boxes.length; i < length; i++) {
			if (boxes[i].checked) {
				results.push( boxes[i].value );
			}
		}	
		return results;
	},
	setCheckboxButtonsSelectedValues: function(name, values) {
		var boxes = document.getElementsByName(name);
		for (var i = 0, length = boxes.length; i < length; i++) {
			if (values.indexOf(boxes[i].value) !== -1) {
				boxes[i].checked = "checked";
			}
		}	
	},
	uniqBy: function(array, attr, use_first_duplicate) {
		var o = {}, i, len = array.length, r = [], k;
		if (len === 1) {
			return [array[0]];
		}
		if (use_first_duplicate) {
			for (i=0; i<len; ++i) {
				o[array[i][attr]] = o[array[i][attr]] || array[i];
			}
		} else {
			for (i=0; i<len; ++i) {
				o[array[i][attr]] = array[i];
			}
		}
		for(k in o) {
			r.push(o[k]);
		}
		return r;
	},
/*
	share: function(where) {
		switch (where) {
			case "twitter" :
//				https://twitter.com/intent/tweet?url=https%3A//youtu.be/5Er4QcNdjVU&text=Sequoia%20Labs%3A%20Lessons%20in%20Leadership%20from%20Doug%20Leone&via=YouTube&related=YouTube,YouTubeTrends,YTCreators

				break;
		}
	},
*/
	isImage: function(str) {
		var ext = str.indexOf(".") !== -1 ? str.toLowerCase().substring(str.lastIndexOf(".")) : null;
		return ext && str.length > ext.length && ['.jpg', '.jpeg', '.gif', '.png'].indexOf(ext) !== -1;
	},
	// Number.isInteger
	isInteger: function(x) {
		return "" + parseInt(x, 10) === "" + x;
	},
	isNumeric: function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	},
	decimalPlaces: function(n, places) {
		let str = n + "";
		let index = str.indexOf(".");
		if (index !== -1) {
			str = str.substring(0, index + 3);
		}
		return str;
	},
	bindHandlers: function(context) {
	    for (var i in context) {
	        if (typeof context[i] === 'function' && i.indexOf('_on') === 0) {
	            context[i] = context[i].bind(context);
	        }
	    }
	},
	getMousePositionXY: function (e, container) {
		let [x, y] = this.getMousePosition(e, container);
		return {x, y};
	},
	getMousePosition: function (e, container) {
	    	e = e.touches ? e.touches[0] : e;
		if (!container) {
			return [e.clientX, e.clientY];
		}

		var rect = container.getBoundingClientRect();
		return [
			e.clientX - rect.left - container.clientLeft,
			e.clientY - rect.top - container.clientTop];
	},
	makeVisible(id, options) {
		let element = document.getElementById(id);
		if (element) {
			// has bug when block=== "start" that scrolls whole document.body
			element.scrollIntoView(Object.assign({block: "nearest", inline: "nearest"}, options));
		}
	},
	scrollToTop(id, scroller_id, use_offsettop) {
		let element = document.getElementById(id);
		let scroller = document.getElementById(scroller_id);
		if (element) {
			let top = use_offsettop ? element.offsetTop : this.getBoundingClientRect(element, scroller).top;
//console.log("element_rect.top=" + this.getBoundingClientRect(element, scroller).top);
console.log("element.offsetTop=" + element.offsetTop);
console.log("scroller.scrollTop=" + scroller.scrollTop);
console.log("scroller.id=" + scroller.id);
console.log("scroller setting to top=" + top);
			scroller.scrollTop = top; 
console.log("now scroller.scrollTop=" + scroller.scrollTop);
		} else {
			ZLog.error("Unable to find element to scroll to '" + id + "'");
		}
        },
	realtimeCountdownUpdaterInterval: null,
	startRealtimeCountdownUpdater: function(options) {
		if (!this.realtimeCountdownUpdaterInterval) {
			this.realtimeCountdownUpdaterInterval = setInterval(this._realtimeCountdownUpdater.bind(this, options), 1000);
		}
	},
	_realtimeCountdownUpdater: function(opts) {
		var timers = document.getElementsByClassName("RealtimeCountdown");
		for (var i = 0; i < timers.length; ++i) {
			let options = JSON.parse(timers[i].getAttribute('data-countdown-options') || "{}");
			let resolution = timers[i].getAttribute('data-countdown-resolution') || "secs";
			let zerohour = parseInt(timers[i].getAttribute('data-countdown-zero-hour'), 10);
			let secs = (zerohour - Date.now())/1000;
			let in_the_past = false;
			if (secs < 0) {
				if (options.future_only) {
					secs = 0;
					if (options.remove_when_done) {
						timers[i].parentNode.removeChild(timers[i]);
						continue;
					}
				} else {
					in_the_past = !!options.negatives;
					secs = -secs;
				}
			}
			let mins = Math.floor(secs / 60);
			secs = Math.floor(secs % 60) + "";
			if (mins >= 1) {
				if (secs.length < 2) {
					secs = "0" + secs;
				}
			}
			if (resolution === "secs") {
				timers[i].innerHTML = (in_the_past ? "-" : "") + (mins ? mins + ":" : "") + secs + (mins ? " minutes" : (options.annotate ? " seconds" : ""));
			} else {
				timers[i].innerHTML = (in_the_past ? "-" : "") + mins + "m";
			}
			if (in_the_past) {
				timers[i].style.color = "d00";
			}
		}
	},
	// https://stackoverflow.com/questions/8619879/javascript-calculate-the-day-of-the-year-1-366
	getDayOfYear: function(date) {
		return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
	},
	getDateFromDayOfYear(doy, year) {
		return new Date(year, 0, doy);
	},
}

/*
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    } 
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}
*/

export default ZUtil;




// WEBPACK FOOTER //
// ./src/zutil.js